// extracted by mini-css-extract-plugin
export default {"modal":"ModalWindow-module--modal--d24de","margins":"ModalWindow-module--margins--7f69e","close":"ModalWindow-module--close--7a1cf","gallery":"ModalWindow-module--gallery--5881c"};